<script setup lang="ts">
  import type { Page } from '@/types/Page.ts'
  import { useForm } from 'laravel-precognition-vue'
  import { ref } from 'vue'
  import { type AxiosResponse } from 'axios'

  definePage({
    meta: {
      public: true,
    },
  })

  const route = useRoute<'content-pages-slug'>()
  const router = useRouter()


  const pageTitle = ref('')
  const pageContent = ref('')
  const fetchData = async () => {
    try {
      const response = await useForm('get', `content/pages/${route.params.slug}`, {}).submit() as AxiosResponse<Page>
      pageTitle.value = response?.data?.name
      pageContent.value = response?.data?.content || ''
      document.title = pageTitle.value
    } catch (e) {
      console.error(e)
      await router.push({ path: '/' })
    }
  }


  await fetchData()

  watch(() => route.params.slug, async () => {
    pageTitle.value = ''
    pageContent.value = ''
    await fetchData()
  })
</script>

<template>
  <v-container
    class="px-4"
    :class="{
      'h-screen': $vuetify.display.smAndDown,
      'bg-surface': $vuetify.display.smAndDown
    }"
    max-width="700"
  >
    <v-card
      class="mx-auto pa-md-4 pa-0"
      elevation="0"
    >
      <v-card-title class="font-weight-bold text-h6 pa-0 mb-8">
        <div class="d-flex align-center ga-3">
          <v-btn
            class="p-0 m-0"
            icon="mdi-arrow-right"
            :ripple="false"
            size="32"
            :to="{path:'/'}"
            variant="text"
          />
          {{ pageTitle }}
        </div>
      </v-card-title>
      <v-card-title class="text-center text-h5 font-weight-bold px-md-4 px-0 pb-2 mb-3">
        {{ pageTitle }}
      </v-card-title>
      <v-card-text class="px-md-4 px-0" v-html="pageContent" />
    </v-card>
  </v-container>
</template>

<style scoped lang="sass">

</style>
